import { RoutePath } from "src/data/Routes";
import { customGroupsDomain } from "./customGroups.domain";
import { dashboardDomain } from "./dashboard.domain";
import { NavDomain } from "./NavDomain";
import { tapeDomain } from "./tape.domain";

/**
 * Domains with class-route-specific navigation behavior, consulted by the NavigateRoute
 * engine through the NavDomain hooks. Storage, LAN and tools are domain modules too, but
 * they plug into the middle of the tree resolution with their own function signatures —
 * see storage.domain.ts, lan.domain.ts and tools.domain.ts.
 */
const navDomains: NavDomain[] = [tapeDomain, dashboardDomain, customGroupsDomain];

/**
 * The only way to reach a domain: hooks must never be invoked across the whole registry,
 * or they would fire for classes the domain does not own. The matchers are mutually
 * exclusive, so the order above carries no meaning.
 */
export function findNavDomain(clsPath: RoutePath): NavDomain {
  return navDomains.find(d => d.matches(clsPath));
}
